module.exports = __webpack_public_path__ + "img/ax.df6363f9.svg";